/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'see more 2': {
    width: 16,
    height: 16,
    viewBox: '0 0 44.98 45',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M44.48 31.54v3.51a9.35 9.35 0 0 1-9.38 9.45H9.9a9.41 9.41 0 0 1-9.4-9.4V9.9A9.41 9.41 0 0 1 9.9.5h3.58M32.42.51v24.1M20.33 12.62h24.14"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/see more 2.js